import React, { useState } from "react";
import { apiPostForm } from "../../utils/api";
import "../MenuList/MenuList.css";
import "./ListaOrdenesPendiente.css";

// PLZ-078 parte 2: las fotos se achican en el celular antes de subir. Una foto de cámara
// (3–5 MB) supera el límite de subida del servidor; a 1600 px y JPEG 80 % queda en ~300–500 KB.
const MAX_PROOF_BYTES = 5 * 1024 * 1024;
const MAX_SIDE = 1600;

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (e) => {
      URL.revokeObjectURL(url);
      reject(e);
    };
    img.src = url;
  });

const prepareProof = async (file) => {
  if (!file.type || !file.type.startsWith("image/")) return file; // PDF u otro: tal cual
  try {
    const img = await loadImage(file);
    const scale = Math.min(1, MAX_SIDE / Math.max(img.width, img.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff"; // fondo blanco para PNG con transparencia
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.8));
    if (!blob || blob.size >= file.size) return file; // si no ganó nada, se manda el original
    return new File([blob], "comprobante.jpg", { type: "image/jpeg" });
  } catch (e) {
    return file; // si el navegador no la puede leer, se manda el original y decide el API
  }
};
export const DepositBank = ({
  bank,
  number_acount,
  type_acount,
  total_value,
  imageUrl,
  idDetalle,
  onUploaded,
  readOnly = false
}) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const handleChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setError(null);
      // Un PDF no se puede mostrar como imagen: se muestra su nombre.
      setPreview(selectedFile.type === "application/pdf" ? null : URL.createObjectURL(selectedFile));
    }
  };

  // PLZ-078 parte 2: antes subía a dev-api escrito a mano, sin comercio, y decía
  // "Evidencia enviada" aunque el API la rechazara.
  const handleUpload = async () => {
    if (!file) return setError("Selecciona la foto o el PDF del comprobante.");
    setSending(true);
    setError(null);
    try {
      if (file.type === "application/pdf" && file.size > MAX_PROOF_BYTES) {
        setError("El PDF pesa más de 5 MB. Envía una captura de pantalla del comprobante.");
        return;
      }
      const toSend = await prepareProof(file);
      const data = await apiPostForm("/qr-code", { qr_code: toSend, service_id: idDetalle });
      if (data?.success === "error") {
        setError(data?.message || "No pudimos recibir tu comprobante, intenta de nuevo.");
        return;
      }
      setUploaded(true);
      if (onUploaded) onUploaded();
    } catch (e) {
      setError("No pudimos enviar el comprobante. Revisa tu conexión e intenta de nuevo.");
    } finally {
      setSending(false);
    }
  };


  return (
    <section >
      {!uploaded && !readOnly && (
        <div className="upload-container">
          <h3>📸 Sube tu evidencia de pago</h3>
          <p>Por favor sube una foto o captura del comprobante de tu transferencia.</p>

          <label htmlFor="file-upload" className="upload-label">
            {preview ? (
              <img src={preview} alt="Evidencia" className="preview-image" />
            ) : (
              <>
                <i className="fa fa-cloud-upload upload-icon"></i>
                <span>{file ? file.name : "Haz clic o arrastra tu imagen aquí"}</span>
              </>
            )}
          </label>

          <input
            id="file-upload"
            type="file"
            accept="image/jpeg,image/png,image/webp,application/pdf"
            onChange={handleChange}
            hidden
          />

          {error && <p style={{ color: "#c0392b", margin: "8px 0" }}>{error}</p>}
          <button onClick={handleUpload} className="upload-button" disabled={sending}>
            {sending ? "Enviando..." : "Enviar Evidencia"}
          </button>
        </div>
      )}



      <div className="container-orden-actual-detalle">
        <div className="element-info">
          <div className="container-info-orden">
            <p className="titulo">⚠️ ORDEN PENDIENTE DE PAGO</p>
          </div>

          <div className="container-info-orden">
            <p className="subtitulo">
              Por favor, proceda a realizar una transferencia utilizando los siguientes datos:
            </p>
          </div>
          <div >
            <div className="datos-transferencia">
              <p>Banco: <b>{bank}</b></p>
              <p>Cuenta #: <b>{number_acount}</b></p>
              <p>Tipo: <b>{type_acount}</b></p>
              <p>Valor: <b className="valor">{total_value}</b></p>

              {imageUrl && (
                <div className="imagen-comprobante">
                  <img src={imageUrl} alt="Comprobante o QR" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};
